// extracted by mini-css-extract-plugin
module.exports = {"space":"Signup_space__10SRX","bottom":"Signup_bottom__19GgB","pad":"Signup_pad__3LNlv","error":"Signup_error__Xdl5_"};